import axios from 'axios';
import { API_URL } from '../ApiConfig'; // Importa a URL base da API

export const ListBug = async () => {
  try {
    const response = await axios.get(`${API_URL}/ListBug`); // Faz a requisição GET
    return response.data; // Retorna os dados da resposta
  } catch (error) {
    console.error("Erro ao listar usuários:", error);
    return { success: false, message: 'Erro ao listar usuários' };
  }
};
